// extracted by mini-css-extract-plugin
export default {"contractInfoSimple":"ContractInfo_contractInfoSimple__V2+OG"};